module.exports = __webpack_public_path__ + "img/send.f110d267.svg";